import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { SessionCookieService } from '@app/core/cookies';
import { PlatformService } from '@app/shared/services/platform/platform.service';
import { map } from 'rxjs/operators';
import { of, Observable, Subscription } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { AuthModalComponent } from '@app/core/user/containers/auth-modal/auth-modal.component';
import { select, Store } from '@ngrx/store';
import { IAppState } from '@app/store';
import { getAuthModalType } from '@app/core/user/store/reducers';
import { ClosePopin } from '@app/store/actions/popin.action';

@Injectable({
  providedIn: 'root'
})
export class DirectShippingEligibilityGuard implements CanActivate {
  private matDialogConfig = {
    disableClose: false,
    maxWidth: 1280,
    data: {
      type: 'login',
      forced: true
    }
  };
  private modalType: string;
  private storeListener: Subscription;

  constructor(
    private sessionService: SessionCookieService,
    private router: Router,
    private plateformService: PlatformService,
    private dialog: MatDialog,
    private store: Store<IAppState>
  ) {
    this.storeListener = this.store.pipe(select(getAuthModalType)).subscribe(
      type => {
        this.modalType = type;
      },
      () => {}
    );
  }

  canActivate(): Observable<boolean> {
    // Since there is no auth nor cookies in server, we return true in SSR.
    if (this.plateformService.isServer) {
      return of(true);
    }

    const hasAuthenticationCookies = this.sessionService.hasSession() && this.sessionService.hasUserId();

    if (!hasAuthenticationCookies) {
      const dialogRef = this.dialog.open(AuthModalComponent, this.matDialogConfig);
      return dialogRef.afterClosed().pipe(
        map(res => {
          this.store.dispatch(new ClosePopin({ name: this.modalType }));
          this.storeListener?.unsubscribe();
          if (res === 'success') {
            return true;
          } else {
            this.router.navigate(['/']);
            return false;
          }
        })
      );
    }
    return of(true);
  }
}
